export const getProtocol = () => process.env.NODE_ENV === 'production' ? 'https' : process.env.API_BASE_URL?.split(':')[0] ?? 'http';
export const protocol = getProtocol();

// TODO: Should we even use API_BASE_URL for setting the baseUrlDomain? This is very weird.
export const baseUrlDomain = process.env.API_BASE_URL?.replace(
  `${protocol}://`,
  '',
);

export const getApiEnv = () => ({
  protocol,
  baseUrlDomain,
});
